import { el } from "@dhx/ts-common/dom";
import { eventHandler, locate } from "@dhx/ts-common/html";
import { dateToStr, strToDate } from "../helpers";
import { IDateFilterMeta, PivotEvents } from "../types";
import { Filter } from "./Filter";

export class DateFilter extends Filter {
	protected _format;
	protected mask;
	protected placeholder;
	protected _meta: IDateFilterMeta;
	protected _inputTimeout: any;

	constructor(config: any) {
		super(config);
		this._htmlEvents.oninput = eventHandler(ev => locate(ev), {
			dhx_date_from: e => {
				this._checkInputText(e, "from");
			},
			dhx_date_to: e => {
				this._checkInputText(e, "to");
			},
		});
	}

	protected _checkInputText(e: any, inputId: string) {
		if (this._inputTimeout) {
			clearTimeout(this._inputTimeout);
			this._inputTimeout = null;
		}
		this._inputTimeout = setTimeout(() => {
			if (!this._validateInput(e.target.value)) {
				e.target.parentNode.classList.add("dhx_alert");
			} else {
				e.target.parentNode.classList.remove("dhx_alert");

				this._meta.filter[inputId] = e.target.value;
				this.config.events.fire(PivotEvents.update);
			}
		}, 500);
	}

	protected _validateInput(val: any): any {
		if (!val) {
			return true;
		}
		return new RegExp(this.mask, "g").test(val);
	}

	protected _createMask() {
		this._format = this._meta.inputFormat;
		const match = this._format.match(/(%[a-zA-Z])/g);
		const delimiter = this._format.match(/([^%a-zA-Z])/g)[0];

		const placeholder = [];
		const mask = [];
		for (const rule of match) {
			switch (rule) {
				case "%d":
					placeholder.push(`DD`);
					mask.push("(0[1-9]|[12]\\d|3[01])");
					break;
				case "%j":
					placeholder.push(`DD`);
					mask.push("([1-9]|[12]\\d|3[01])");
					break;
				case "%m":
					placeholder.push(`MM`);
					mask.push("(0?[1-9]|1[012])");
					break;
				case "%n":
					placeholder.push(`MM`);
					mask.push("([1-9]|1[012])");
					break;
				case "%Y":
					placeholder.push(`YYYY`);
					mask.push("[1-2][0-9]{3}");
					break;
				case "%y":
					placeholder.push(`YY`);
					mask.push("[0-9]{2}");
					break;
			}
		}

		this.mask = mask.join(`\\W`);
		this.placeholder = placeholder.join(delimiter);
	}

	protected _setMeta(oldMeta: IDateFilterMeta) {
		this._meta = oldMeta || ({} as any);
		this._meta.values = this._meta.values || [...this._data];
		this._meta.filter = this._meta.filter || { from: "", to: "" };

		this._meta.inputFormat =
			this._meta.inputFormat || this._item.inputFormat || this._item.format || "%d.%m.%Y";
		this._createMask();
	}

	protected _getFilterInput() {
		return el(".dhx_filter--date-field", [
			el(".dhx_date_input", [
				el("input.dhx_input", {
					class: "dhx_date_from",
					type: "text",
					placeholder: this.placeholder,
					_key: "from",
				}),
			]),
			el(".dhx_date_input", [
				el("input.dhx_input", {
					class: "dhx_date_to",
					type: "text",
					placeholder: this.placeholder,
					_key: "to",
				}),
			]),
		]);
	}

	protected _formatLabel(label: any): any {
		return dateToStr(new Date(label), this._meta.inputFormat);
	}

	protected _getCheckboxData() {
		const filter = this._meta.filter as IDateFilterMeta["filter"];
		const data = this._data;
		const operation = (cur, from, to) => cur >= from && cur <= to;
		if (filter.from || filter.to) {
			const from = filter.from
				? strToDate(filter.from, this._meta.inputFormat).getTime()
				: Math.min(...data);
			const to = filter.to ? strToDate(filter.to, this._meta.inputFormat).getTime() : Math.max(...data);
			return data.filter(item => operation(item, from, to));
		} else {
			return data;
		}
	}
}
